import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const Spinner = styled(LoadingOutlined)`
  font-size: 12px;
`;

export default Spinner;
